export default "__VITE_ASSET__D1ury$s0__"